export const SIGN_IN_EMAIL_COOKIE_NAME = 'signInEmail'
export const SIGN_IN_EMAIL_PARAM = 'signInEmail'
export const EMAIL_FIELD_NAME = 'email'
export const UNAUTHORIZED_SESSION_ERROR = 'UNAUTHORIZED_SESSION'

export const ANALYTICS_GOOGLE_PROVIDER = 'Google'
export const ANALYTICS_APPLE_PROVIDER = 'Apple'
export const ANALYTICS_EMAIL_PROVIDER = 'email'

export const RESIGNIN_DEBOUNCE_TIME = 3000
export const IS_FROM_RESIGNIN_PAGE_COOKIE_NAME = 'isFromResigninPage'
export const LAST_SIGNING_METHOD_COOKIE_NAME = 'lastSigningMethod'

// expired tokens
export const INVALID_TOKEN_ERROR_MESSAGE = '401'
export const EXPIRED_PARAM_TOKEN_VALUE = 'expiredToken'
export const HOME_ERROR_PARAM = 'error'

export const HTTP_EMAIL_PROVIDER = 'http-email'
export const GOOGLE_PROVIDER = 'google'
export const APPLE_PROVIDER = 'apple'

export const signInTypeMap: Record<string, string> = {
  [GOOGLE_PROVIDER]: ANALYTICS_GOOGLE_PROVIDER,
  [APPLE_PROVIDER]: ANALYTICS_APPLE_PROVIDER,
  [HTTP_EMAIL_PROVIDER]: ANALYTICS_EMAIL_PROVIDER,
}

export enum EmailMessagingStatus {
  deliverable = 'deliverable',
  undeliverable = 'undeliverable',
  risky = 'risky',
  unknown = 'unknown',
}

export const EMAIL_ERROR_PARAM = 'emailError'
export const REDIRECT_RETURN_PARAM = 'redirectReturn'
